import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import type { PlotShape } from "@pdfking/renderer-api"
import { PlotFunction } from "@pdfking/renderer-api"

import { PlotMixin as mixin } from "../mixins/PlotMixin"
import { PlotMedia } from "./PlotMedia"
import { PlotPath } from "./PlotPath"
import { PlotRect } from "./PlotRect"
import { PlotShapeGroup } from "./PlotShapeGroup"
import { PlotText } from "./PlotText"

// One level of the shape tree. Groups recurse through `PlotShapeGroup`, so the
// SVG nests exactly as the plot does.
const components = {
  [PlotFunction.PLOT_GROUP]: PlotShapeGroup,
  [PlotFunction.PLOT_MEDIA]: PlotMedia,
  [PlotFunction.PLOT_PATH]: PlotPath,
  [PlotFunction.PLOT_RECT]: PlotRect,
  [PlotFunction.PLOT_TEXT]: PlotText,
} as const

export const PlotShapes = CreateRenderFunction({
  mixins: [mixin] as const,
  props: {
    media_count: 0,
    shapes: [] as PlotShape[],
  },
  render() {
    return (
      <>
        {this.shapes.map((a: PlotShape, i: number) => {
          const Component = components[a.enum]
          return (
            <Component
              // @ts-expect-error — a.enum discriminates correctly but TS can't narrow through dynamic component lookup
              action={a}
              context={this.context}
              key={i}
              media_click={this.media_click}
              media_count={this.media_count}
              printable={this.printable}
              request_media={this.request_media}
            />
          )
        })}
      </>
    )
  },
})
